/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
	mode: 'history',
	routes: [
	{ 
		path: '/',
		name: 'home',
		component: require('./components/Home.vue')
	},
	{ 
		path: '/registration',
		name: 'registration',
		component: require('./components/RegistrationView.vue')
	},
	{ 
		path: '/reset/:token',
		name: 'reset',
		component: require('./components/PasswordResetView.vue')
	},
	{ 
		path: '/legal',
		name: 'legal',
		component: require('./components/LegalView.vue')
	},
	{ 
		path: '/jobs',
		name: 'jobs',
		component: require('./components/JobsView.vue')
	},
	{ 
		path: '/info',
		name: 'info',
		component: require('./components/InfoView.vue')
	},
	{ 
		path: '/feed',
		name: 'feed',
		component: require('./components/FeedView.vue')
	},
	{
		path: '/admin/',
		name: 'admin',
		component: require('./components/Admin/AdminView.vue'),
		children: [
		{
			path: 'home',
			alias: '',
			component: require('./components/Admin/Dashboard.vue')
		},
		{
			path: 'profile',
			component: require('./components/Admin/Profile.vue')
		},
		{
			path: 'doctors',
			component: require('./components/Admin/DoctorList.vue')
		},
		{
			path: 'patients',
			component: require('./components/Admin/PatientList.vue')
		},
		{
			path: 'patient/:id',
			component: require('./components/Admin/Patient.vue')
		},
		{
			path: 'feed',
			component: require('./components/Admin/FeedList.vue')
		}
		]
	},
	{
		path: '/:name',
		name: 'doctor',
		component: require('./components/PublicDoctorView.vue')		
	},
	{
		path: '*',
		component: require('./components/MissingView.vue')
	}
	]
})

export default router;



// WEBPACK FOOTER //
// ./src/router.js